import {handleActions} from 'redux-actions';
import {actions} from './actions';
import {reducers as _reducers} from './reducers';


const defaultState = {
    property: {
        raw: {},
        properties: [],
        cluster: [],
        count: 0
    },
    pagination: {
        currentPage: 0,
        currentProperties: [],
        count: 0
    },
    error: null,
    status: null,
    sort: {
        by: 'Price',
        order: 'ASC',
        type: 'number'
    },
    display:'map',
    params: {
        viewport:{},
        bounds:{},
        urlQuery: undefined,
        parameters: undefined
    }
};


const reducers = handleActions(new Map([
    ..._reducers
]), defaultState);

export {
    actions, reducers
};
